import React from 'react';
import './style.scss';

export const BigGreenButton = ({children, ghost, onClick}) => {
  const classList = ['app-big-green-button'];
  if (typeof ghost === 'boolean') {
    classList.push('app-big-green-button_ghost');
  }

  return <button className={classList.join(' ')} onClick={() => onClick()}>{children}</button>;
}